var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M170.5 69C170.5 69 151.5 8 86.25 7.99999C21 7.99999 2 69 2 69",
  stroke: "url(#paint0_linear_520_469)",
  strokeWidth: 4,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M86.5 7.55473C151.944 7.55474 171 69 171 69L171 0L2.00001 -1.47744e-05L2 69C2 69 21.0564 7.55473 86.5 7.55473Z",
  fill: "url(#paint1_linear_520_469)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_520_469",
  x1: 181,
  y1: 89,
  x2: 2,
  y2: 137,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#10E3A4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.63464,
  stopColor: "#10E3A4",
  stopOpacity: 0.299313
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#10E3A4",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_520_469",
  x1: 89.2581,
  y1: 165.701,
  x2: 86.729,
  y2: -0.503323,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#11E0A2",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#11E0A2",
  stopOpacity: 0
})));

function SvgChartCrab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 134,
    viewBox: "0 0 173 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartCrab);
export default __webpack_public_path__ + "static/media/Chart_Crab.3dc357b9fbed526fb77b8c654ab1552a.svg";
export { ForwardRef as ReactComponent };